module.exports = __webpack_public_path__ + "static/img/speed.dbf5c414.png";